<div class="export">
    <button
        class="btn-common btn-exporter"
        (click)="onShowTypeExport()"
        [disabled]="disabledBtnImport"
    >
        <span>{{ 'IRONSIDE.product-list.export' | translate | uppercase }}</span
        ><mat-spinner
            *ngIf="loadingExport && sessionStorageService.getFilters()?.isfavLis"
            [diameter]="15"
        ></mat-spinner>
    </button>
    <div
        class="content-exporter-fav"
        [ngStyle]="height < 514 ? { bottom: '34px' } : {}"
        *ngIf="exportVisible"
    >
        <div *ngFor="let item of exportOption">
            <div *ngIf="item?.permission" class="exporter-item d-flex align-items-center gap-2">
                <p-checkbox
                    [(ngModel)]="itemExportSelected"
                    [value]="item.key"
                    [label]="'export.' + item.label | translate"
                    [inputId]="item.key"
                    [disabled]="isDisabled(item.key) || item.quantity === 0"
                ></p-checkbox>
            </div>
        </div>
        <div>
            <div class="action-show-exporter">
                <button class="btn-export-common" (click)="onCancelExport()">
                    <span>{{
                        'IRONSIDE.tabview-product.CANCEL' | translate | lowercase | titlecase
                    }}</span>
                </button>

                <button
                    class="btn-export-common truncate"
                    [disabled]="!itemExportSelected.length || loadingExport || isProgress"
                    (click)="onExportResource()"
                    [ngStyle]="{
                        backgroundColor:
                            !itemExportSelected.length || loadingExport || isProgress
                                ? '#0000008c'
                                : ''
                    }"
                    style="display: flex; align-items: center; gap: 4px; justify-content: center"
                >
                    <span>{{
                        'IRONSIDE.product-list.export' | translate | lowercase | titlecase
                    }}</span>
                </button>
            </div>

            <div *ngIf="loadingExport || isProgress" class="progress-bar-exporter loading-dots">
                {{ 'export.EXPORTING_FILE' | translate }}<span>.</span><span>.</span><span>.</span>
                <p-progressBar [value]="progressNumber"></p-progressBar>
            </div>
        </div>
    </div>
</div>
